import { useT } from '@/i18n'
import '@/navigation.css'

export default function NavigationButton() {
  const t = useT()

  return (
    <button
      className="nav-fab"
      onClick={() => { window.location.href = '/navigate' }}
      aria-label={t.navigation.button}
      title={t.navigation.button}
    >
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="3" />
        <path d="M12 2v4M12 18v4M2 12h4M18 12h4" />
        <path d="M12 2a10 10 0 0 1 10 10" opacity="0.4" />
        <path d="M12 2a10 10 0 0 0-10 10" opacity="0.4" />
        <path d="M12 22a10 10 0 0 1-10-10" opacity="0.4" />
        <path d="M12 22a10 10 0 0 0 10-10" opacity="0.4" />
      </svg>
    </button>
  )
}
